<script lang="ts">
  export let icon = "";
</script>

<span class="material-icons pf-select__icon" id="pf-select-icon">{icon}</span>